import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  accountActivationAlertTitle: {
    id: 'account-activation.alert.title',
    defaultMessage: 'Activate your account so you can log back in',
    description: 'Title for account activation alert which is shown after the registration',
  },
});

export default messages;
